module.exports = __webpack_public_path__ + "static/media/searchSections.4dc30c86.jpg";